import { globalEntitlements } from '../utils/globalEntitlements';

export const WEBSITE_TOOLS_BUNDLE_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.websiteToolsBundle.buyBox.bulletPoint1' },
          { title: 'productPage.websiteToolsBundle.buyBox.bulletPoint2' },
          { title: 'productPage.websiteToolsBundle.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.websiteToolsBundle.buyBox.productName',
        interactService: {
          service: 'website_tools_bundle',
          isPurchasedByOrderTask: true,
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/online-tools-bundle-mockup.png',
      alt: 'productPage.websiteToolsBundle.heroPicture.altText',
    },
    headline: 'productPage.websiteToolsBundle.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.websiteToolsBundle.page.subheader',
  },
  showCase: {
    title: 'productPage.websiteToolsBundle.showCase.title',
    stylesContainer: {
      variantContainer: 'outlined',
    },
    stylesItem: {
      bgrColorItem: 'default',
    },
    items: [
      {
        image: '/s2/raster/custom-website-tile.png',
      },
      {
        image: '/s2/raster/domain-name-tile.png',
      },
      {
        image: '/s2/raster/domain-privacy-tile.png',
      },
      {
        image: '/s2/raster/email-address-tile.png',
      },
    ],
  },
  benefit: {
    title: 'productPage.websiteToolsBundle.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/webrounded.svg',
        title: 'productPage.websiteToolsBundle.valueProp.propTitle1',
        description: 'productPage.websiteToolsBundle.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/languagerounded.svg',
        title: 'productPage.websiteToolsBundle.valueProp.propTitle2',
        description: 'productPage.websiteToolsBundle.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/alternateemailrounded.svg',
        title: 'productPage.websiteToolsBundle.valueProp.propTitle3',
        description: 'productPage.websiteToolsBundle.valueProp.shortCopy3',
      },
      {
        icon: '/s2/material-icons/info.svg',
        title: 'productPage.websiteToolsBundle.valueProp.propTitle4',
        description: 'productPage.websiteToolsBundle.valueProp.shortCopy4',
      },
      {
        icon: '/s2/material-icons/computerrounded.svg',
        title: 'productPage.websiteToolsBundle.valueProp.propTitle5',
        description: 'productPage.websiteToolsBundle.valueProp.shortCopy5',
      },
      {
        icon: '/s2/icon/more-tools-fill.svg',
        title: 'productPage.websiteToolsBundle.valueProp.propTitle6',
        description: 'productPage.websiteToolsBundle.valueProp.shortCopy6',
      },
    ],
  },
  highlight: {
    icon: '/s2/material-icons/trendinguprounded.svg',
    title: 'productPage.websiteToolsBundle.topFeature.title',
    subheader: 'productPage.websiteToolsBundle.topFeature.subheader',
    image: '/s2/raster/florist-phone-outside.png',
    alt: 'productPage.websiteToolsBundle.topFeature.altText',
  },
  howItWorks: {
    title: 'productPage.websiteToolsBundle.howItWorks.title',
    items: [
      {
        description: 'productPage.websiteToolsBundle.howItWorks.step1',
      },
      {
        description: 'productPage.websiteToolsBundle.howItWorks.step2',
      },
      {
        description: 'productPage.websiteToolsBundle.howItWorks.step3',
      },
      {
        description: 'productPage.websiteToolsBundle.howItWorks.step4',
      },
      {
        description: 'productPage.websiteToolsBundle.howItWorks.step5',
      },
    ],
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
    video: 'h59b0zg2sy',
  },
  socialProof: {
    image: '/s2/raster/lp-website-empower-vision-services.png',
    alt: 'productPage.websiteToolsBundle.testimonial.altText',
    testimonial: {
      quote: 'productPage.websiteToolsBundle.testimonial.quote',
      source: 'productPage.websiteToolsBundle.testimonial.source',
      author: 'productPage.websiteToolsBundle.testimonial.author',
    },
  },
  faqs: {
    title: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faq1',
        answer: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faq2',
        answer: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faq3',
        answer: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faqAnswer3',
      },
      {
        question: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faq4',
        answer: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faqAnswer4',
      },
      {
        question: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faq5',
        answer: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faqAnswer5',
      },
      {
        question: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faq6',
        answer: 'productPage.websiteToolsBundle.frequentlyAskedQuestions.faqAnswer6',
      },
    ],
  },
  assistance: {
    title: 'productPage.websiteToolsBundle.needAssistance.title',
    getInTouch: 'productPage.websiteToolsBundle.needAssistance.getInTouch',
    actions: 'productPage.websiteToolsBundle.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({
    ctaText: 'productPage.websiteToolsBundle.buyBox.buttonLabel',
  })
    .currentProductNotPurchased()
    .build(),
};
